import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import StarsRating from 'Pods/Shared/StarsRating'
import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'
import Icon from 'Pods/Shared/Icon/Icon'

function Reviewer({
  avatar = '',
  name,
  rating,
  showStarsRating = true,
  createdAt = '',
}) {
  return (
    <div className="reviewer">
      <UserAvatar
        size="large"
        img={avatar}
        userName={name}
      />
      <div className="reviewer__info">
        <h4 className="u-inline-block">{name}</h4>
        {createdAt && (
          <p
            className="u-inline-block heading-14 text-light-grey u-mb0"
          >
            Posted on: {createdAt}
          </p>
        )}
        <div>
          {showStarsRating ? (
            <Fragment>
              <span className="u-mr10 review">
                <span className="text-semibold">{rating}</span>/5
              </span>
              <StarsRating rating={rating} customClass="height-12" readonly />
            </Fragment>
          ) : (
            <span className="product-ratings__thumbs">
              {rating > 0 ? (
                <p>
                  <span className="heading-14 text-green">Positive</span>
                  <Icon type={['far', 'thumbs-up']} className="text-green u-ml10" />
                </p>
              ) : (
                <p>
                  <span className="heading-14 text-light-grey">Negative</span>
                  <Icon type={['far', 'thumbs-down']} className="text-light-grey u-ml10" />
                </p>
              )}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

Reviewer.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  showStarsRating: PropTypes.bool,
  createdAt: PropTypes.string,
}

export default Reviewer
